import React, { Component } from 'react'

import Logo from 'ui/Logo'
import Loader from 'ui/Loader'
import Form from 'ui/Form'
import Input from 'ui/Input'
import Container from 'ui/Container'

const classname = 'auth'

class Auth extends Component {

  constructor(props){
    super(props)
    this.state = {
      username:'',
      password:''
    }
  }

  handleChange(e) {
    const name = e.target.name
    this.setState({[name]: e.target.value});
  }

  onSubmit(res){
    this.props.login(res)
  }

  render(){
    if(this.props.loading){
      return <Loader/>
    } else {
      return (
        <Container classname={classname}>
          <div className="auth-wrapper">
            <img className="sounds-logo" src="img/hotpod-sounds.svg"/>
            <Form 
              classname={classname} 
              submit={(res)=>this.onSubmit(res)}
              message={this.props.message}
              change={(e)=>this.handleChange(e)}
              altInput>
            </Form>
          </div>
        </Container>
      )
    }
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/modules/AuthContainer.js